const notification = {
    // headings
    create: 'Create Notification',
    studentAlerts: 'Student Alerts',

    // List
    notificationList: 'Notification List',
    name: 'Receiver Name',
    program: 'Program',
    programType: 'Program Type',
    type: 'Type',
    subject: 'Subject',
    message: 'Message',
    created_at: 'Created At',
    student_number: 'Student Number',
    status: 'Status',
    status_message: 'Status Message',
    date: 'Date',
    email: 'Email',
    mobile: 'Mobile',
    delivery_timestamp:'Delivery Timestamp',
    processing_timestamp:'Processing Timestamp',

    // Labels
    notificationType: 'Notification Type',
    email: 'Email',
    sms: 'SMS (SMS fees will incur)',
    both: 'Both',
    to: 'To',
    selectStudents: 'Select Students',
    selectFaculty: 'Select Faculty',
    notifiable: 'No notification receiver specified yet, please select at least one student or faculty.',
    noStudentFound: 'No student found under selected program.',
    noStudentFoundUnderType: 'No student found under selected program type.',
    onlyEmail: 'Subject (only visible in e-mail)',

    // Notification Editors
    editor: 'Notification Templates',
    editorEdit: 'Edit Notification Template',
    createEdit: 'Create Notification Template',
    template: 'Template',
    available_variables:'Available variables: ',
    nameText: 'Name',
    action: 'Action',
    title: 'Title',
    type: 'Type',
    status: 'Status',
    activate: 'Activate',
    deactivate: 'Deactivate',
    selectedAllStudents:'All students are selected.',
    deleteConfirm:'Are you sure you want want to delete this record?'
};

export default notification;
